import { create } from "zustand";

interface HeadlinesFilterState {
  portfoliosFilter: number[];
  portfoliosHighlight: number[];
  setPortfoliosFilter: (ids: number[]) => void;
  setPortfoliosHighlight: (ids: number[]) => void;
}

/**
 * Global store for Headlines filter selections.
 * Used to track portfolio filter/highlight selections for sound alerts.
 */
export const useHeadlinesFilterStore = create<HeadlinesFilterState>((set) => ({
  portfoliosFilter: [],
  portfoliosHighlight: [],
  setPortfoliosFilter: (ids) => set({ portfoliosFilter: ids }),
  setPortfoliosHighlight: (ids) => set({ portfoliosHighlight: ids }),
}));
